<template>
  <div style="display: flex">
    <el-select
      :ref="refVal"
      v-bind="$attrs"
      @change="change"
      :style="styleCss"
      v-model="val"
      :size="size"
      :allow-create="allowCreate"
      :multiple="multiple"
      :placeholder="placeholder"
      default-first-option
      :clearable="clearable"
      filterable
    >
      <el-option
        v-for="item in showOptions"
        :key="item.index"
        :label="selfDefinedTm ? item.value : item.label"
        :value="item.value"
      >
        <div v-if="selfDefinedTm">
          <span style="float: left; width: 80px">{{ item.value }}</span>
          <span :title="item.label" class="spanDesc">{{ item.label }}</span>
        </div>
      </el-option>
    </el-select>
  </div>
</template>

<script>
import { Select, Option } from 'element-ui'
export default {
  name: 'form-select1',
  components: {
    'el-select': Select,
    'el-option': Option
  },
  data() {
    return {
      showOptions: [],
      valMap: {}
    }
  },
  props: {
    refVal: { type: String, default: 'formselect' },
    styleCss: { type: String, default: 'width:100%;' },
    options: Array,
    join: String,
    selfDefinedTm: Boolean,
    isSendToken: { type: Boolean, default: true },
    text: { type: String },
    clearable: Boolean,
    scope: Object,
    param: Object,
    selectFirst: Boolean,
    url: { type: String, required: false },
    callBack: Function,
    dataKey: {
      type: Object,
      required: false,
      default: function () {
        return { label: 'label', value: 'value' }
      }
    },
    sendJson: Boolean,
    value: { required: false, default: '' },
    allowCreate: { type: Boolean, default: false },
    multiple: { type: Boolean, default: false },
    placeholder: { type: String, default: '请选择' },
    size: { type: String, default: 'small' },
    collapseTags: { type: Boolean, default: false }
  },
  model: {
    prop: 'value',
    event: 'setval'
  },
  computed: {
    isJoin() {
      return this.multiple && !!this.join
    },
    val: {
      get() {
        if (this.isJoin) {
          return this.value ? this.value.split(this.join) : []
        }
        return this.value
      },
      set(newVal) {
        var data = newVal
        if (this.isJoin) {
          data = data.join(this.join)
        }
        this.$emit('setval', data)
      }
    }
  },
  methods: {
    queryAllCategory() {
      var that = this
      that[that.sendJson ? '$postObj' : '$post'](
        that.url,
        that.param,
        (data, headers) => {},
        (data) => {},
        this.isSendToken
      )
        .then((resp) => {
          if (resp.data.code == 0) {
            var data = resp.data.data
            if (data.Data) {
              data = data.Data
            }
            that.showOptions = []
            that.valMap = []
            data.forEach(function (item, index) {
              var option = {
                label: item[that.dataKey.label],
                value: item[that.dataKey.value]
              }
              that.showOptions.push(option)
              that.valMap[option.value] = option
              if (that.selectFirst && index == 0) {
                that.val = item[that.dataKey.value]
              }
              if (that.callBack && typeof that.callBack == 'function') {
                that.callBack(data)
              }
              //that.value=[1,2];
            })
          } else {
            alert(resp.data.msg)
          }
        })
        .catch((error) => {
          // 请求失败处理
          alert('请求发生错误！')
          console.error(error)
        })
    },
    change(val) {
      var lab = this.valMap[val].label
      this.$emit('change', { lab: lab, val: val }, this.valMap[val])
    }
  },

  mounted() {
    var that = this
    if (that.url) {
      that.queryAllCategory()
    } else {
      that.showOptions = that.options
    }
  }
}
</script>

<style lang="stylus" scoped>
.spanDesc {
  float: left;
  color: #8492a6;
  font-size: 13px;
  max-width: 280px;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
